import {createRootContextHook} from 'common/util/react';

export const useReportLayoutManager = createRootContextHook(`reportLayoutManager`);
